// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"ddccf522","208":"2a58eb88","462":"7e5c763c","480":"d60e7846","688":"8ee48374","820":"84aa917f","825":"7dca8367","841":"bed0c075","985":"2c11a9fe"}[chunkId] + ".chunk.css";
};